import type Phaser from "phaser";

const GROUND_COLOR = 0x09101c;
const BOUNDARY_COLOR = 0x8fb7d8;
const BOUNDARY_ALPHA = 0.32;
const BOUNDARY_WIDTH = 2.5;

export function drawSimpleWorldGround(
  layer: Phaser.GameObjects.Graphics,
  arenaRadius: number,
): void {
  layer.fillStyle(GROUND_COLOR, 0.92);
  layer.fillCircle(0, 0, arenaRadius);
}

export function drawSimpleWorldBoundary(
  layer: Phaser.GameObjects.Graphics,
  arenaRadius: number,
): void {
  layer.lineStyle(BOUNDARY_WIDTH, BOUNDARY_COLOR, BOUNDARY_ALPHA);
  layer.strokeCircle(0, 0, arenaRadius);
}
